import React, {useMemo} from 'react';
import styled from 'styled-components';
import HeaderItem from './HeaderItem';
import {useSelector} from 'react-redux';
import Utility from '../../../../util/utilityfunctions';
import {
	toggleFrameModal,
	frameCommunicationEvents,
	frameEvents,
	useFrameService,
	useFrameData
} from '@ey/canvascoreservices';
import {
	useAresUrlTrackChangesParameters,
	useAresUrlCompareResponsesParameters
} from '../../../../util/Ares/customHooks';
import Env from '../../../../util/env';
import {getConfiguration} from '../HeaderSectionDisplayConfiguration';
import {frameSubEvent} from '../../../../util/uiconstants';
import {useActiveFrame, useQuery} from '../../../../util/customHooks';
import {loadStorage} from '../../../Common/localStorage';

export default function HeaderList({headers, documentTypeId, taskId, source, documentIds}) {
	const engagementId = useSelector((store) => store.engagementId);

	const frameService = useFrameService();

	const query = useQuery();

	const snapshotId = loadStorage('selectedTrackChangesSnapshotId');

	const {frameKey, toggled} = useActiveFrame();

	const frameData = useFrameData();

	const config = useMemo(() => getConfiguration(source), [source]);

	const {configQueryParams, configFrameArgs, name} = useMemo(() => {
		if (config) {
			return {
				configQueryParams: config.queryParameters,
				configFrameArgs: config.frameArgs,
				name: config.name
			};
		}

		return {};
	}, [config]);

	const compareResponsesParameter = useAresUrlCompareResponsesParameters();

	const trackChangesParameter = useAresUrlTrackChangesParameters();

	const {documentId} = useMemo(() => {
		return config.compareResponse ? compareResponsesParameter : trackChangesParameter;
	}, [config, compareResponsesParameter, trackChangesParameter]);

	const onShowDrawerChanges = ({sectionId, headerId, sectionName}) => {
		const isCompareResponse = source === 'CompareResponses';

		if (!frameKey) {
			let kronosBaseUrl = Env.getURL('kronos_web');

			if (kronosBaseUrl && kronosBaseUrl.endsWith('/')) {
				kronosBaseUrl = kronosBaseUrl.slice(0, -1);
			}

			const queryString = {...configQueryParams};

			if (window.self !== window.top) {
				queryString.sourceFrameKey = query.framekey;
			}

			if (source === 'TrackChanges') {
				queryString.snapshotId = snapshotId;
			}

			const uri = Utility.getAresTaskListNavigationUrl(
				documentId,
				headerId,
				sectionId,
				engagementId,
				taskId,
				queryString,
				documentTypeId,
				false,
				source === 'CompareResponses'
			);

			const args = {
				isAresView: true,
				variant: 'slideout',
				frameArgs: {
					...configFrameArgs,
					name: `${name}: ${Utility.getHtmlTextElement(sectionName)}`,
					src: kronosBaseUrl + uri,
					frameStore: {
						documentIds
					}
				}
			};

			if (window.self === window.top) {
				toggleFrameModal(args);
			} else {
				frameService.openFrameFromChild(args);
			}
		} else {
			if (!toggled) {
				toggleFrameModal({frameArgs: {event: frameEvents.TOGGLE_DRAWER}});
			}

			if (window.self === window.top) {
				frameService.updateFrame(frameKey, {
					name: `${name}: ${Utility.getHtmlTextElement(sectionName)}`,
					deepLinkSrc: window?.location?.href
				});

				frameData.addData(frameKey, {documentIds});

				frameService.sendMessageToChildFrame(frameKey, {
					frameKey,
					event: frameCommunicationEvents.MESSAGE,
					subEvent: isCompareResponse
						? frameSubEvent.COMPARE_SECTION_CHANGED
						: frameSubEvent.TRACK_CHANGES_SECTION_CHANGED,
					documentId,
					headerId,
					sectionId,
					taskId,
					engagementId,
					documentTypeId,
					target: window.top.location.origin,
					queryParameters: configQueryParams,
					documentIds
				});
			}
		}
	};

	return (
		<Wrapper className="StyledHeaderList">
			{headers.map((header) => {
				const show = header?.sections?.filter((s) => s.isDisplayed === true && s.isSummary === false)?.length > 0;

				if (show) {
					return (
						<section className="headerItemWrapper">
							<HeaderItem
								key={header?.id}
								header={header}
								documentTypeId={documentTypeId}
								taskId={taskId}
								source={source}
								onShowDrawerChanges={onShowDrawerChanges}
								selectedDocumentsCount={documentIds?.length}
							/>
						</section>
					);
				}
			})}
		</Wrapper>
	);
}

const Wrapper = styled.section`
	display: flex;
	flex-direction: column;
	flex: 1;
	height: 100%;
	padding: 0 0 0 var(--px-20);
	overflow-y: auto;
	position: relative;
	.headerItemWrapper {
		background: var(--neutrals-00white);
		border-radius: var(--px-12);
		border: var(--px-1) solid var(--neutrals-200);
		margin-bottom: var(--px-24);
	}
`;
